var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"root",class:{
    [_vm.$style['mdc-global-navigation']]: true,
    [_vm.$style['mdc-global-navigation--collapsed']]: _vm.provider.isCollapsed,
  }},[_c('div',{ref:"menu",class:{
      [_vm.$style['mdc-global-navigation__menu']]: true,
    }},[_c('nav',{ref:"nav",class:_vm.$style['mdc-global-navigation__nav']},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }